// extracted by css-extract-rspack-plugin
export default {"root":"HzMdQ","event":"QAAV_","title":"t82ZC","revertButton":"HHv8H","iconCircle":"x_mcK"};